<template>
    <div class="copy row">
        Copyright ©2023. All Rights Reserved By <a href="https://site.peaklinkdemo.com/" class="peak"> Peak Link</a>
    </div>
</template>

<script>

export default {
    name: "Copy",
    components: {
    },
    data() {
        return {
        };
    },
};

</script>


<style lang="scss">
.copy{
    justify-content: center;
    padding: 20px;
    background: var(--main-blue);
    color: #fff;
}
.peak{
    color: var(--main-yellow);
    font-size: 17px;
    margin-left: 5px;
}
.peak:hover{
    color: var(--main-yellow);
    // font-weight: bold;
}

</style>